// extracted by mini-css-extract-plugin
export default {"baseStyles":"_1f14m"};